import React from 'react';
import { string } from 'prop-types';
import IconWrapper from '../IconWrapper';
import Messages from '../../Messages';

const SellerInbox = ({ username }) => (
    <IconWrapper>
        <Messages username={username} drawerType={Messages.DRAWER_TYPES.MESSAGES} showAsIcons />
    </IconWrapper>
);

SellerInbox.propTypes = {
    username: string.isRequired,
};

export default SellerInbox;
